"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonTitle = exports.Button = exports.ButtonWrapper = exports.ItemsSection = exports.NoItemsIcon = exports.NoItemsTitle = exports.NoItemsWrapper = exports.NoItemsSection = exports.ButtonSelectAll = exports.Title = exports.TitleWrapper = exports.Wrapper = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "ShipmentCardContainerStyles__Wrapper",
  componentId: "sc-16n04xb-0"
})(["height:100%;width:100%;background:#212a3c;color:white;border-radius:1.2em;position:relative;box-sizing:border-box;display:flex;flex-direction:column;"]);

exports.Wrapper = Wrapper;

var TitleWrapper = _styledComponents["default"].div.withConfig({
  displayName: "ShipmentCardContainerStyles__TitleWrapper",
  componentId: "sc-16n04xb-1"
})(["background:#1b2335;border-radius:1.2em;padding:1.2rem;display:flex;flex-direction:row;align-items:center;justify-content:space-between;"]);

exports.TitleWrapper = TitleWrapper;

var Title = _styledComponents["default"].h1.withConfig({
  displayName: "ShipmentCardContainerStyles__Title",
  componentId: "sc-16n04xb-2"
})(["font-size:1.5em;"]);

exports.Title = Title;

var ButtonSelectAll = _styledComponents["default"].button.withConfig({
  displayName: "ShipmentCardContainerStyles__ButtonSelectAll",
  componentId: "sc-16n04xb-3"
})(["outline:none;border:0;cursor:pointer;color:white;background:transparent;font-size:0.8rem;"]);

exports.ButtonSelectAll = ButtonSelectAll;

var NoItemsSection = _styledComponents["default"].div.withConfig({
  displayName: "ShipmentCardContainerStyles__NoItemsSection",
  componentId: "sc-16n04xb-4"
})(["display:flex;flex-direction:column;align-items:center;padding-top:4rem;padding-bottom:4.2rem;flex:1 auto;"]);

exports.NoItemsSection = NoItemsSection;

var NoItemsWrapper = _styledComponents["default"].figure.withConfig({
  displayName: "ShipmentCardContainerStyles__NoItemsWrapper",
  componentId: "sc-16n04xb-5"
})([""]);

exports.NoItemsWrapper = NoItemsWrapper;

var NoItemsTitle = _styledComponents["default"].figcaption.withConfig({
  displayName: "ShipmentCardContainerStyles__NoItemsTitle",
  componentId: "sc-16n04xb-6"
})(["color:#91969e;font-weight:bold;"]);

exports.NoItemsTitle = NoItemsTitle;

var NoItemsIcon = _styledComponents["default"].img.withConfig({
  displayName: "ShipmentCardContainerStyles__NoItemsIcon",
  componentId: "sc-16n04xb-7"
})([""]);

exports.NoItemsIcon = NoItemsIcon;

var ItemsSection = _styledComponents["default"].div.withConfig({
  displayName: "ShipmentCardContainerStyles__ItemsSection",
  componentId: "sc-16n04xb-8"
})(["margin-bottom:4.6rem;flex:1 auto;overflow-y:auto;&::-webkit-scrollbar{width:10px;}&::-webkit-scrollbar-track{background:#212a3c;}&::-webkit-scrollbar-thumb{background:#79a3ff;border-radius:12px;}&::-webkit-scrollbar-thumb:hover{background:#79a3ff;}"]);

exports.ItemsSection = ItemsSection;

var ButtonWrapper = _styledComponents["default"].div.withConfig({
  displayName: "ShipmentCardContainerStyles__ButtonWrapper",
  componentId: "sc-16n04xb-9"
})(["display:flex;flex-direction:row;justify-content:center;position:absolute;width:100%;bottom:1.2rem;"]);

exports.ButtonWrapper = ButtonWrapper;

var Button = _styledComponents["default"].button.withConfig({
  displayName: "ShipmentCardContainerStyles__Button",
  componentId: "sc-16n04xb-10"
})(["width:95%;border-radius:6px;height:2.5rem;background:#2940a2;outline:none;border:0;cursor:pointer;"]);

exports.Button = Button;

var ButtonTitle = _styledComponents["default"].span.withConfig({
  displayName: "ShipmentCardContainerStyles__ButtonTitle",
  componentId: "sc-16n04xb-11"
})(["font-weight:bold;font-size:1rem;color:#8a97cc;"]);

exports.ButtonTitle = ButtonTitle;